import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, ChevronDownOutline, useDisclosure } from '@bonusly/design-system';

import { Message } from '../../lib';
import { CompleteMessage } from '../message';

interface MessageListProps {
	messages: Message[];
}

export const MessageList: FC<MessageListProps> = ({ messages }) => {
	const { t } = useTranslation('feedback');
	const thread = useDisclosure({ defaultIsOpen: false });

	const { visible, showToggle, overflowCount } = useMemo((): {
		visible: Message[];
		showToggle: boolean;
		overflowCount: number;
	} => {
		const visible = thread.isOpen ? messages : messages.slice(-3);
		const overflowCount = messages.length - visible.length;
		const showToggle = overflowCount > 0;

		return { visible, showToggle, overflowCount };
	}, [messages, thread]);

	return (
		<>
			{showToggle && (
				<Button size="sm" variant="alpha" onClick={thread.onToggle} py={1} px={3} w="full">
					{t('message.show_previous', {
						count: overflowCount,
					})}
					<ChevronDownOutline size="sm" />
				</Button>
			)}

			{visible.map((message) => {
				return <CompleteMessage date={message.createdAt} key={message.id} text={message.text} userId={message.userId} userName={message.user.name} />;
			})}
		</>
	);
};
